import { ColumnStore } from "@bryntum/schedulerpro";
import { WIDGET_KEYS } from "../../other/constants/WidgetKeys.jsx";
import { EntityMainNameDefault, swivuGridSorterFn } from "../../other/utils/utils.jsx";
import SwivuSortColumn from "./SwivuSortColumn.jsx";

export default class IncentiveCategoryColumn extends SwivuSortColumn {
  static get fields() {
    return [
      { name: "swivuListTitle", readOnly: true, defaultValue: "Category" },
      { name: "swivuListSearchKey", readOnly: true, defaultValue: "name" },
    ];
  }

  static get $name() {
    return "IncentiveCategoryColumn";
  }

  static get type() {
    return WIDGET_KEYS.incentiveCategoryColumn;
  }

  static get defaults() {
    return {
      text: "Category",
      field: "categoryId",
      flex: 1,
      editor: false
    };
  }

  get canEmptySwivuList() {
    return false;
  }

  renderer({ record }) {
    return EntityMainNameDefault({ text: record.categoryRecord?.name });
  }

  onLoad(project, { editorHandler, swivuTab }) {
    this.project = project;
    this.editorHandler = editorHandler;
    this.swivuTab = swivuTab;
  }

  get swivuListItems() {
    return this.project.incentiveTagCategoryStore.query(() => true, true).sort(swivuGridSorterFn.bind({ field: "name" }));
  }

  getSwivuListItemDisplayValue(record) {
    return record.name;
  }

  getSelectedSwivuListItem(record) {
    return this.project.incentiveTagCategoryStore.getById(record.categoryId);
  }

  onSwivuListSelectionChange(record, [categoryRecord]) {
    this.swivuTab.handleRecordUpdate("categoryId", categoryRecord.id, record);
  }
}

ColumnStore.registerColumnType(IncentiveCategoryColumn);